import { Component } from '@angular/core';

@Component({
  selector: 'tln-recruitee-logo',
  styleUrl: './recruitee-logo.component.less',
  templateUrl: './recruitee-logo.component.html',
  standalone: true,
})
export class RecruiteeLogoComponent {}
